<div class="main-ho-status">
    <div>
        <p class="title-section">Estado</p>
    </div>
    <div class="loading-shade" *ngIf="isLoading">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>

    <table mat-table [dataSource]="wellEvents" id="tblEvents" *ngIf="showEvents">
        <ng-container matColumnDef="wellId">
            <mat-header-cell *matHeaderCellDef> wellId </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="eventType">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Tipo de Evento </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.eventType}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dateOpsStart">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Inicio </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.dateOpsStart}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dateOpsEnd">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Fin </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.dateOpsEnd}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="objective">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Objetivo </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.objective}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mainCause">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Causa </mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-cs"> {{element.mainCause}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="fullCicleComplete">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Full Cicle <br>Complete </mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-cs"> {{element.fullCicleComplete}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="confirmEvent">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> 
                Confirmar Evento 
                <span *ngIf="wellEvents.length && countConfirm == 0" class="span-confirm">*Confirmar al menos un evento como obligatorio</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index">
                <span class="table-numbers-right-align-cs">
                    <mat-slide-toggle [disabled]="disableToggle || readOnlyContent"
                        [checked]="element.confirmEvent" (change)="toggleConfirmEvent(i); onSectionTouched('status')">
                    <span *ngIf="!element.confirmEvent">No corresponde al Handover en Realización</span>
                    <span *ngIf="element.confirmEvent">Corresponde al Handover en Realización</span>
                    </mat-slide-toggle>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="7">
                <div class="footer">
                    <div class="footer-no-data">No se encontraron datos.</div>
                    <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
                </div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooterEvents}"></mat-footer-row>
    </table>

    <table mat-table [dataSource]="wellStatusProduction" id="tblWellData" *ngIf="!showEvents">
        <ng-container matColumnDef="uwi">
            <mat-header-cell *matHeaderCellDef> uwi </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.uwi}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="productionType">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Tipo de Producción </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.productionType}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="extractionSystem">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Sistema </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.extractionSystem}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Estado </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="6">
                <div class="footer">
                    <div class="footer-no-data">No se encontraron datos.</div>
                    <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
                </div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumnsStatus"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsStatus;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooterWell}"></mat-footer-row>
    </table>
</div>
